import { useEffect, useState } from 'react';
import { apiFetch, v1Path } from '../../lib/api';
import { isMemberDto, parseItems, type MemberDto } from '../../lib/work-types';

let cache: Promise<Map<string, MemberDto>> | null = null;

function loadMembers(): Promise<Map<string, MemberDto>> {
  if (!cache) {
    cache = apiFetch<unknown>(v1Path('/members?limit=100&offset=0'))
      .then((res) => {
        const members: MemberDto[] = parseItems(res, isMemberDto, 'members');
        return new Map(members.map((member) => [member.user_id, member]));
      })
      .catch((err: unknown) => {
        cache = null;
        throw err;
      });
  }
  return cache;
}

/** user_id → org member. Empty map until loaded or when the list cannot be read. */
export function useMembers(): Map<string, MemberDto> {
  const [members, setMembers] = useState<Map<string, MemberDto>>(() => new Map());
  useEffect(() => {
    let cancelled = false;
    loadMembers()
      .then((map) => {
        if (!cancelled) setMembers(map);
      })
      .catch(() => {
        if (!cancelled) setMembers(new Map());
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return members;
}
